import { render, staticRenderFns } from "./IconHeartActive.vue?vue&type=template&id=d0dc9126&"
import script from "./IconHeartActive.vue?vue&type=script&lang=js&"
export * from "./IconHeartActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports